export enum ShiftType {
	LEFT = 1,
	BIGLEFT = 2,
	RIGHT = 3,
	RIGHTRIGHT = 4
}
